import { render, staticRenderFns } from "./rh_colaborador_detalhes.vue?vue&type=template&id=4de760d5&scoped=true&"
import script from "./rh_colaborador_detalhes.vue?vue&type=script&lang=js&"
export * from "./rh_colaborador_detalhes.vue?vue&type=script&lang=js&"
import style0 from "./rh_colaborador_detalhes.vue?vue&type=style&index=0&id=4de760d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de760d5",
  null
  
)

export default component.exports